import { ref, watch } from 'vue';

import { addDatadogRumUserData, startDatadogRumRecording } from '@/datadog';

export const setupAuthState = () => {
  const isAuthenticated = ref(false);
  const knockUserToken = ref('');
  const accessToken = ref('');
  const userId = ref('');

  watch(
    userId,
    () => {
      if (userId.value) {
        addDatadogRumUserData();
        startDatadogRumRecording();
      }
    },
    { immediate: true },
  );

  return {
    isAuthenticated,
    userId,
    accessToken,
    knockUserToken,
  };
};

export type AuthState = ReturnType<typeof setupAuthState>;
